import { render, staticRenderFns } from "./PasswordResetForm.html?vue&type=template&id=316ef3ea&scoped=true&"
import script from "./PasswordResetForm.vue?vue&type=script&lang=js&"
export * from "./PasswordResetForm.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetForm.scss?vue&type=style&index=0&id=316ef3ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316ef3ea",
  null
  
)

export default component.exports